<script setup lang="ts"></script>

<template lang="pug">
q-btn.btn-dialog-close-popup(
  v-close-popup
  flat
  round
  dense
  size="xl"
  icon="close").absolute.top-2.right-2.z-top
</template>
